import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import { useState, useRef } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { message } from 'antd';
import { Loader2 } from 'lucide-react';

// 内部步骤状态：1-输入, 2-loading, 3-成功, 4-失败
type InnerStep = 1 | 2 | 3 | 4;

// Loading 旋转图标组件
function LoadingSpinner({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.9993 1.07812C9.19025 1.07813 9.37339 1.15398 9.50841 1.28901C9.64344 1.42403 9.7193 1.60717 9.7193 1.79813V3.95812C9.7193 4.14908 9.64344 4.33222 9.50841 4.46724C9.37339 4.60227 9.19025 4.67812 8.9993 4.67812C8.80834 4.67812 8.62521 4.60227 8.49018 4.46724C8.35515 4.33222 8.2793 4.14908 8.2793 3.95812V1.79813C8.2793 1.60717 8.35515 1.42403 8.49018 1.28901C8.62521 1.15398 8.80834 1.07813 8.9993 1.07812Z"
        fill="#02183A"
      />
      <path
        d="M12.9593 2.14334C13.1246 2.23882 13.2453 2.39608 13.2947 2.58052C13.3441 2.76496 13.3183 2.96149 13.2228 3.12686L12.1428 4.99778C12.0959 5.08032 12.0331 5.15277 11.958 5.21094C11.883 5.26912 11.7972 5.31188 11.7055 5.33676C11.6139 5.36164 11.5182 5.36814 11.4241 5.35591C11.3299 5.34367 11.2391 5.31292 11.1569 5.26544C11.0746 5.21797 11.0026 5.15469 10.9449 5.07926C10.8873 5.00384 10.8451 4.91774 10.8208 4.82594C10.7965 4.73414 10.7906 4.63845 10.8035 4.54437C10.8164 4.45029 10.8477 4.35969 10.8957 4.27778L11.9757 2.40686C12.0712 2.24149 12.2285 2.12083 12.4129 2.07141C12.5974 2.02199 12.7939 2.04786 12.9593 2.14334Z"
        fill="#02183A"
      />
      <path
        d="M15.8587 5.03967C15.9542 5.20504 15.9801 5.40156 15.9307 5.586C15.8813 5.77045 15.7606 5.92771 15.5952 6.02319L13.7243 7.10319C13.559 7.19716 13.3633 7.22194 13.1798 7.17213C12.9963 7.12231 12.84 7.00194 12.7449 6.83729C12.6498 6.67263 12.6238 6.47706 12.6724 6.29325C12.721 6.10943 12.8403 5.9523 13.0043 5.85615L14.8752 4.77615C15.0406 4.68067 15.2371 4.6548 15.4216 4.70422C15.606 4.75364 15.7633 4.8743 15.8587 5.03967Z"
        fill="#02183A"
      />
      <path
        d="M16.9203 9.00125C16.9203 9.0958 16.9017 9.18943 16.8655 9.27678C16.8293 9.36414 16.7763 9.44351 16.7094 9.51037C16.6426 9.57722 16.5632 9.63026 16.4758 9.66644C16.3885 9.70263 16.2949 9.72125 16.2003 9.72125H14.0403C13.8494 9.72125 13.6662 9.64539 13.5312 9.51037C13.3962 9.37534 13.3203 9.19221 13.3203 9.00125C13.3203 8.81029 13.3962 8.62716 13.5312 8.49213C13.6662 8.35711 13.8494 8.28125 14.0403 8.28125H16.2003C16.2949 8.28125 16.3885 8.29987 16.4758 8.33606C16.5632 8.37224 16.6426 8.42527 16.7094 8.49213C16.7763 8.55899 16.8293 8.63836 16.8655 8.72572C16.9017 8.81307 16.9203 8.9067 16.9203 9.00125Z"
        fill="#4C4C4C"
      />
      <path
        d="M15.8592 12.9593C15.7637 13.1246 15.6065 13.2453 15.422 13.2947C15.2376 13.3441 15.041 13.3183 14.8757 13.2228L13.0048 12.1428C12.9222 12.0959 12.8498 12.0331 12.7916 11.958C12.7334 11.883 12.6907 11.7972 12.6658 11.7055C12.6409 11.6139 12.6344 11.5182 12.6466 11.4241C12.6589 11.3299 12.6896 11.2391 12.7371 11.1569C12.7846 11.0746 12.8478 11.0026 12.9233 10.9449C12.9987 10.8873 13.0848 10.8451 13.1766 10.8208C13.2684 10.7965 13.3641 10.7906 13.4582 10.8035C13.5522 10.8164 13.6428 10.8477 13.7248 10.8957L15.5957 11.9757C15.761 12.0712 15.8817 12.2285 15.9311 12.4129C15.9805 12.5974 15.9547 12.7939 15.8592 12.9593Z"
        fill="#666666"
      />
      <path
        d="M12.9603 15.8587C12.795 15.9542 12.5985 15.9801 12.414 15.9307C12.2296 15.8813 12.0723 15.7606 11.9768 15.5952L10.8968 13.7243C10.8029 13.559 10.7781 13.3633 10.8279 13.1798C10.8777 12.9963 10.9981 12.84 11.1627 12.7449C11.3274 12.6498 11.523 12.6238 11.7068 12.6724C11.8906 12.721 12.0477 12.8403 12.1439 13.0043L13.2239 14.8752C13.3193 15.0406 13.3452 15.2371 13.2958 15.4216C13.2464 15.606 13.1257 15.7633 12.9603 15.8587Z"
        fill="#7F7F7F"
      />
      <path
        d="M8.9993 16.9203C8.90474 16.9203 8.81112 16.9017 8.72376 16.8655C8.63641 16.8293 8.55704 16.7763 8.49018 16.7094C8.42332 16.6426 8.37029 16.5632 8.3341 16.4758C8.29792 16.3885 8.2793 16.2949 8.2793 16.2003V14.0403C8.2793 13.8494 8.35515 13.6662 8.49018 13.5312C8.62521 13.3962 8.80834 13.3203 8.9993 13.3203C9.19025 13.3203 9.37339 13.3962 9.50841 13.5312C9.64344 13.6662 9.7193 13.8494 9.7193 14.0403V16.2003C9.7193 16.2949 9.70067 16.3885 9.66449 16.4758C9.62831 16.5632 9.57527 16.6426 9.50841 16.7094C9.44156 16.7763 9.36218 16.8293 9.27483 16.8655C9.18747 16.9017 9.09385 16.9203 8.9993 16.9203Z"
        fill="#999999"
      />
      <path
        d="M5.03967 15.8592C4.8743 15.7637 4.75364 15.6065 4.70422 15.422C4.6548 15.2376 4.68067 15.041 4.77615 14.8757L5.85615 13.0048C5.90308 12.9222 5.96587 12.8498 6.04092 12.7916C6.11596 12.7334 6.20177 12.6907 6.29341 12.6658C6.38505 12.6409 6.4807 12.6344 6.57486 12.6466C6.66902 12.6589 6.75983 12.6896 6.84206 12.7371C6.9243 12.7846 6.99632 12.8478 7.054 12.9233C7.11168 12.9987 7.15387 13.0848 7.17814 13.1766C7.20241 13.2684 7.20828 13.3641 7.19542 13.4582C7.18255 13.5522 7.15121 13.6428 7.10319 13.7248L6.02319 15.5957C5.92771 15.761 5.77045 15.8817 5.586 15.9311C5.40156 15.9805 5.20504 15.9547 5.03967 15.8592Z"
        fill="#ACACAC"
      />
      <path
        d="M2.14138 12.9623C2.04591 12.7969 2.02004 12.6004 2.06945 12.416C2.11887 12.2315 2.23954 12.0743 2.4049 11.9788L4.27582 10.8988C4.4411 10.8048 4.63685 10.78 4.82033 10.8298C5.00382 10.8797 5.16015 11 5.25522 11.1647C5.35029 11.3293 5.37637 11.5249 5.32777 11.7087C5.27917 11.8925 5.15984 12.0497 4.99582 12.1458L3.1249 13.2258C2.95953 13.3213 2.76301 13.3472 2.57857 13.2977C2.39412 13.2483 2.23686 13.1277 2.14138 12.9623Z"
        fill="#BFBFBF"
      />
      <path
        d="M1.08008 9.00125C1.08008 8.81029 1.15594 8.62716 1.29096 8.49213C1.42599 8.35711 1.60912 8.28125 1.80008 8.28125H3.96008C4.15103 8.28125 4.33417 8.35711 4.46919 8.49213C4.60422 8.62716 4.68008 8.81029 4.68008 9.00125C4.68008 9.19221 4.60422 9.37534 4.46919 9.51037C4.33417 9.64539 4.15103 9.72125 3.96008 9.72125H1.80008C1.60912 9.72125 1.42599 9.64539 1.29096 9.51037C1.15594 9.37534 1.08008 9.19221 1.08008 9.00125Z"
        fill="#CCCCCC"
      />
      <path
        d="M2.14138 5.03967C2.23686 4.8743 2.39412 4.75364 2.57857 4.70422C2.76301 4.6548 2.95953 4.68067 3.1249 4.77615L4.99582 5.85615C5.07837 5.90308 5.15081 5.96587 5.20899 6.04092C5.26717 6.11596 5.30993 6.20177 5.33481 6.29341C5.35968 6.38505 5.36619 6.4807 5.35395 6.57486C5.34171 6.66902 5.31097 6.75983 5.26349 6.84206C5.21601 6.9243 5.15274 6.99632 5.07731 7.054C5.00188 7.11168 4.91579 7.15387 4.82399 7.17814C4.73219 7.20241 4.6365 7.20828 4.54242 7.19542C4.44834 7.18255 4.35774 7.15121 4.27582 7.10319L2.4049 6.02319C2.23954 5.92771 2.11887 5.77045 2.06945 5.586C2.02004 5.40156 2.04591 5.20504 2.14138 5.03967Z"
        fill="#E5E5E5"
      />
      <path
        d="M5.03967 2.14334C5.20504 2.04786 5.40156 2.02199 5.586 2.07141C5.77045 2.12083 5.92771 2.24149 6.02319 2.40686L7.10319 4.27778C7.19716 4.44306 7.22194 4.6388 7.17213 4.82229C7.12231 5.00577 7.00194 5.16211 6.83729 5.25717C6.67263 5.35224 6.47706 5.37832 6.29325 5.32972C6.10943 5.28112 5.9523 5.1618 5.85615 4.99778L4.77615 3.12686C4.68067 2.96149 4.6548 2.76496 4.70422 2.58052C4.75364 2.39608 4.8743 2.23882 5.03967 2.14334Z"
        fill="#F2F2F2"
      />
    </svg>
  );
}

export interface AccountInfo {
  id?: number;
  username?: string;
  url?: string;
  name?: string;
  avatar_url?: string;
  profile_description?: string;
  post_count?: number;
  media_count?: number;
  like_count?: number | null;
  follower_count?: number;
  following_count?: number;
  social_type?: string;
}

// 平台示例图片映射
const PLATFORM_EXAMPLE_IMAGES: Record<string, string> = {
  ONLYFANS: '/images/erasa/platforms/examples/onlyfans.png',
  TIKTOK: '/images/erasa/platforms/examples/Tiktok.png',
  X: '/images/erasa/platforms/examples/X.png',
  INSTAGRAM: '/images/erasa/platforms/examples/Instagram.png',
  PATREON: '/images/erasa/platforms/examples/Patreon.png',
  CHATURBATE: '/images/erasa/platforms/examples/Chaturbate.png',
  FANSLY: '/images/erasa/platforms/examples/Fansly.png',
  FANVUE: '/images/erasa/platforms/examples/Fanvue.png',
  MANYVIDS: '/images/erasa/platforms/examples/Manyvids.png',
  REDDIT: '/images/erasa/platforms/examples/Reddit.png',
  PORNHUB: '/images/erasa/platforms/examples/Pornhub.png',
  FANSONE: '/images/erasa/platforms/examples/Fansone.png',
  OTHER: '',
};

// 平台名称映射
const PLATFORM_NAMES: Record<string, string> = {
  ONLYFANS: 'OnlyFans',
  TIKTOK: 'TikTok',
  X: 'X',
  INSTAGRAM: 'Instagram',
  PATREON: 'Patreon',
  CHATURBATE: 'Chaturbate',
  FANSLY: 'Fansly',
  FANVUE: 'Fanvue',
  MANYVIDS: 'Manyvids',
  REDDIT: 'Reddit',
  PORNHUB: 'Pornhub',
  FANSONE: 'Fansone',
  OTHER: 'Other',
};

// 平台图标映射
const PLATFORM_ICONS: Record<string, string> = {
  ONLYFANS: '/images/erasa/platforms/new/OnlyFans.png',
  TIKTOK: '/images/erasa/platforms/new/TikTok.png',
  X: '/images/erasa/platforms/new/X.png',
  INSTAGRAM: '/images/erasa/platforms/new/Instagram.png',
  PATREON: '/images/erasa/platforms/new/Patreon.png',
  CHATURBATE: '/images/erasa/platforms/new/Chaturbate.png',
  FANSLY: '/images/erasa/platforms/new/Fansly.png',
  FANVUE: '/images/erasa/platforms/new/Fanvue.png',
  MANYVIDS: '/images/erasa/platforms/new/Manyvids.png',
  REDDIT: '/images/erasa/platforms/new/Reddit.png',
  PORNHUB: '/images/erasa/platforms/new/Pornhub.png',
  FANSONE: '/images/erasa/platforms/new/Fansone.png',
  OTHER: '/images/erasa/platforms/new/Other.png',
};

interface Step2Props {
  platform: string;
  onBack: () => void;
  onClose: () => void;
  onSubmit: (username: string) => Promise<{ success: boolean; data?: AccountInfo }>;
  onConfirmAdd: (accountInfo: AccountInfo) => void;
  showUpgradeDesc: boolean;
  showUpgradeDescLoading: boolean;
  setShowUpgradeDesc: (value: boolean) => void;
  addAccountLoading: boolean;
  /** 文案变体，'shadowban' 时使用检测泄露与假账号的专属标题 */
  copyVariant?: 'default' | 'shadowban';
}

export default function Step2({
  platform,
  onBack,
  onClose,
  onSubmit,
  onConfirmAdd,
  showUpgradeDesc,
  showUpgradeDescLoading,
  setShowUpgradeDesc,
  addAccountLoading,
  copyVariant = 'default',
}: Step2Props) {
  const { t } = useTranslation('common');
  const router = useRouter();
  const [username, setUsername] = useState('');
  const [innerStep, setInnerStep] = useState<InnerStep>(1);
  const [accountInfo, setAccountInfo] = useState<AccountInfo | null>(null);
  const [avatarError, setAvatarError] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const platformName = PLATFORM_NAMES[platform] || platform;
  const exampleImage = PLATFORM_EXAMPLE_IMAGES[platform] || PLATFORM_EXAMPLE_IMAGES.OTHER;
  const platformIcon = PLATFORM_ICONS[platform] || PLATFORM_ICONS.OTHER;

  const handleSubmit = async () => {
    if (!username.trim()) return;

    // 进入 loading 状态
    setInnerStep(2);

    try {
      // 如果用户选择的是 other，则需要判断用户输入的是否是 url
      if (platform === 'OTHER') {
        const isUrl = /^https?:\/\//i.test(username.trim());
        if (!isUrl) {
          message.warning(t('Please enter the full URL, for example: https://example.com/username'));
          setInnerStep(1);
          return;
        }
      }
      const result = await onSubmit(username.trim());
      if (result.success && result.data) {
        setAccountInfo(result.data);
        setInnerStep(3); // 成功状态
      } else {
        setInnerStep(4); // 失败状态
      }
    } catch {
      setInnerStep(4); // 失败状态
    }
  };

  // 渲染输入区域（步骤1显示示例图片，步骤2/3/4显示确认区域）
  const renderContent = () => {
    if (innerStep === 1) {
      if (!exampleImage) {
        return null;
      }

      // 输入状态 - 显示示例图片
      return (
        <div className={styles.exampleSection}>
          <div className={styles.exampleHeader}>
            <span className={styles.exampleLabel}>{t('What to Enter')}</span>
          </div>
          <div className={styles.exampleImage}>
            <Image src={exampleImage} alt={`${platformName} example`} width={464} height={192} />
          </div>
        </div>
      );
    }

    // 步骤2/3/4 - 显示账号确认区域
    return (
      <div className={styles.confirmSection}>
        <div className={styles.confirmHeader}>
          <span className={styles.confirmLabel}>{t('Verifying Your Account')}</span>
        </div>

        <div className={styles.confirmCard}>
          {innerStep === 2 && (
            // Loading 状态
            <div className={styles.loadingContent}>
              <span className={styles.loadingText}>{t('Protection for this account will start with Erasa.')}</span>
              <div className={styles.loadingBox}>
                <LoadingSpinner className={styles.loadingIcon} />
                <span className={styles.loadingBoxText}>{t('Check your accounts')}</span>
              </div>
            </div>
          )}

          {innerStep === 3 && accountInfo && (
            // 成功状态
            <div className={styles.successRow}>
              <div className={styles.userInfo}>
                <div className={styles.userAvatar}>
                  <Image
                    src={
                      avatarError
                        ? '/images/erasa/dashboard/default_avatar.png'
                        : accountInfo.avatar_url || '/images/erasa/dashboard/default_avatar.png'
                    }
                    alt="avatar"
                    width={46}
                    height={46}
                    onError={() => setAvatarError(true)}
                  />
                  {/* <img src={accountInfo.avatar_url || '/images/dashboard/defaultAvatar.png'} alt="" /> */}
                  <div className={styles.platformBadge}>
                    <Image src={platformIcon} alt={platformName} width={20} height={20} />
                  </div>
                </div>
                <div className={styles.userDetails}>
                  <p className={styles.userName}>{accountInfo.name || '-'}</p>
                  <p className={styles.userHandle}>{accountInfo.username ? `@${accountInfo.username}` : '-'}</p>
                </div>
              </div>
              <div className={styles.successTag}>
                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1 4.11111L5.55172 9L13 1"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className={styles.successTagText}>OK</span>
              </div>
            </div>
          )}

          {innerStep === 4 && (
            // 失败状态
            <>
              <div className={styles.userInfo}>
                <div className={styles.defaultAvatar}>
                  <Image src={'/images/erasa/dashboard/default_avatar.png'} alt="avatar" width={46} height={46} />
                </div>
                <div className={styles.userDetails}>
                  <p className={styles.userName}>{username.startsWith('@') ? username : `@${username}`}</p>
                </div>
              </div>
              <div className={styles.errorTag}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.125 1.875L1.875 10.125"
                    stroke="#FF4747"
                    strokeWidth="1.33333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1.875 1.875L10.125 10.125"
                    stroke="#FF4747"
                    strokeWidth="1.33333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className={styles.errorTagText}>{t('Invalid account')}</span>
              </div>
            </>
          )}
        </div>

        {innerStep === 3 && showUpgradeDesc && (
          <div className={styles.upgradeDesc}>
            <div>{t('Your current plan allows only one social account.')}</div>
            <div>
              {t('Please upgrade to continue.')}
              {` `}
              <span
                className={styles.upgradeLink}
                onClick={() => {
                  onClose();
                  router.push('/plan');
                }}
              >
                {t('Upgrade Now')}
              </span>
            </div>
          </div>
        )}

        {innerStep === 4 && (
          <>
            <p className={styles.errorMessage}>
              {t("We couldn't find this account. Please double-check and try again.")}
            </p>
            <p className={styles.helpLink}>
              {t('Need help?')} <Link href="mailto:erasaprotection@erasa.net">{t('Contact Us')} →</Link>
            </p>
          </>
        )}
      </div>
    );
  };

  // 确定按钮是否可点击
  const isButtonActive = innerStep === 1 ? username.trim() : innerStep === 3 && !showUpgradeDesc;
  const isButtonDisabled =
    showUpgradeDescLoading ||
    addAccountLoading ||
    showUpgradeDesc ||
    innerStep === 2 ||
    (innerStep === 1 && !username.trim()) ||
    innerStep === 4;

  const handleButtonClick = () => {
    if (showUpgradeDescLoading || addAccountLoading) return;

    if (innerStep === 1) {
      handleSubmit();
    } else if (innerStep === 3 && accountInfo) {
      onConfirmAdd(accountInfo);
    }
  };

  // 处理返回按钮点击
  const handleBackClick = () => {
    setShowUpgradeDesc(false);
    if (innerStep === 1) {
      // 如果是输入状态，返回到 Step1
      onBack();
    } else {
      // 如果是 loading/成功/失败状态，返回到输入状态
      setInnerStep(1);
      setAccountInfo(null);
    }
  };

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.mainTitleRow}>
            <button className={styles.backBtn} onClick={handleBackClick} aria-label={t('Back')}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00065 12.6693L3.33398 8.0026L8.00065 3.33594"
                  stroke="#02183A"
                  strokeOpacity="0.6"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.6673 8H3.33398"
                  stroke="#02183A"
                  strokeOpacity="0.6"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <h1 className={styles.mainTitle}>
              {copyVariant === 'shadowban'
                ? t('Scan for Leaks & Fake Accounts')
                : t('2 Quick Steps to Get Protected')}
            </h1>
            <button className={styles.closeBtn} onClick={onClose} aria-label={t('Close')}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4L12 12M12 4L4 12" stroke="#4A5565" strokeWidth="1.33" strokeLinecap="round" />
              </svg>
            </button>
          </div>
          <div className={styles.stepInfo}>
            <h2 className={styles.stepTitle}>{t('Step2: Add Your Account')}</h2>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className={styles.content}>
        <div className={styles.formSection}>
          {/* Username Input */}
          <div className={styles.inputGroup}>
            <label className={styles.label}>{t('Your Account')}</label>
            <div className={styles.textInput}>
              <div className={styles.inputPlatformIcon}>
                <Image src={platformIcon} alt={platformName} width={16} height={16} />
              </div>
              <input
                ref={inputRef}
                type="text"
                value={username}
                style={{ backgroundColor: '#ffffff' }}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !isButtonDisabled) {
                    handleButtonClick();
                  }
                }}
                placeholder={t(
                  platform === 'OTHER' ? 'Paste your profile link' : 'Paste your profile link or username',
                )}
                disabled={innerStep !== 1}
              />
              {(innerStep === 3 || innerStep === 4) && (
                <button
                  className={styles.clearBtn}
                  onClick={() => {
                    setInnerStep(1);
                    setAccountInfo(null);
                    setUsername('');
                    setShowUpgradeDesc(false);
                    setAvatarError(false);
                    // 延迟获取焦点，等待 disabled 状态更新
                    setTimeout(() => {
                      inputRef.current?.focus();
                    }, 0);
                  }}
                  aria-label={t('clear', 'clear')}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="8" fill="#EDEDED" />
                    <path
                      d="M4.80078 4.79688L8.00078 7.99688M11.2008 11.1969L8.00078 7.99688M8.00078 7.99688L11.2008 4.79688L4.80078 11.1969"
                      stroke="#1B1716"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>

          {/* 根据状态渲染不同内容 */}
          {renderContent()}
        </div>
      </div>

      {/* Footer */}
      <div className={styles.footer}>
        <button
          className={`${styles.submitBtn} ${isButtonActive ? styles.active : ''}`}
          onClick={handleButtonClick}
          disabled={isButtonDisabled}
          aria-busy={showUpgradeDescLoading || addAccountLoading}
        >
          {(showUpgradeDescLoading || addAccountLoading) && (
            <Loader2 className={styles.submitBtnLoadingIcon} size={16} />
          )}
          <span>{t('Confirm & Start Protection')}</span>
        </button>
      </div>
    </div>
  );
}
